<script setup lang="ts">
type PillType = 'success' | 'warning' | 'error' | 'info';

const props = withDefaults(
  defineProps<{
    type?: PillType;
    label: string;
    icon?: boolean;
  }>(),
  { type: 'info' as PillType, icon: true },
);

const pillType = (): PillType => props.type ?? 'info';

function bgFor(type: PillType): string {
  switch (type) {
    case 'success':
      return 'bg-bg-pill text-brand-700';
    case 'warning':
      return 'bg-bg-pill text-text-primary';
    case 'error':
      return 'bg-error-container text-on-error-container';
    default:
      return 'bg-bg-pill text-text-secondary';
  }
}

function dotFor(type: PillType): string {
  switch (type) {
    case 'success':
      return 'bg-brand';
    case 'warning':
      return 'bg-text-secondary';
    case 'error':
      return 'bg-error';
    default:
      return 'bg-info';
  }
}
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 rounded-pill px-3 py-1.5 text-label-medium font-medium"
    :class="bgFor(pillType())"
  >
    <span
      v-if="icon"
      class="inline-block w-2 h-2 rounded-pill"
      :class="dotFor(pillType())"
      aria-hidden="true"
    />
    {{ label }}
  </span>
</template>
